import { DEFAULT_BROCHURE } from "@/constants/site";

const EMERGENT_RE = /emergent(agent|\.sh)/i;
const LEGACY_RE = /bondstein/i;

export function resolveBrochureUrl(url) {
  if (url && !EMERGENT_RE.test(url) && !LEGACY_RE.test(url)) return url;
  return DEFAULT_BROCHURE;
}
